import { FILE_ERRORS } from '~constants/errors';

export const isUploaded = (file, uploadedFiles) =>
  uploadedFiles.some(uploadedFile => uploadedFile.name === file.name);

export const isUnknownError = fileError => fileError === FILE_ERRORS.UNKNOWN;
